// extracted by mini-css-extract-plugin
export var attachment = "_ra-a";
export var emailContainer = "_ra-4";
export var emailContentPaddedContainer = "_ra-b";
export var emailHeader = "_ra-6";
export var emailIframe = "_ra-3";
export var emailInfoIcon = "_ra-9";
export var emailShortenedSummary = "_ra-e";
export var infoDropdown = "_ra-0";
export var infoRowBoundedContent = "_ra-d";
export var internal = "_ra-5";
export var merchant = "_ra-8";
export var messageInputContainer = "_ra-h";
export var normal = "_ra-7";
export var replyCard = "_ra-f";
export var subtleButton = "_ra-1";
export var subtleButtonIconContainer = "_ra-2";
export var toggleViewRepliesButton = "_ra-c";
export var wrappingText = "_ra-g";